import type { LeDataContentBlock } from '~/types/leData';

// A staged change (lens_draft) is a change list now, drawn inside askRichard's bubble with the sentence.
const SELF_FRAMED_BLOCK_TYPES = new Set(['lens_scope', 'lens_plan']);

export function hasSelfFramedBlock(blocks: ReadonlyArray<LeDataContentBlock> | undefined): boolean {
  return Boolean(blocks?.some((block) => SELF_FRAMED_BLOCK_TYPES.has(block.type)));
}
